import { CartUpdateEvent } from '@theme/events';

/**
 * Knack in-cart upgrade / subscribe swap. ORIGINAL Horizon code.
 *
 * The server-rendered prompt (snippets/knack-cart-upgrade.liquid) chooses one highest-value action:
 * switch a one-time line to subscription, or upgrade a pack line to the next box size. On click we
 * perform a NON-DESTRUCTIVE swap: add the new line FIRST (so a failure never empties the cart), then
 * remove the original line by its key, preserving the Loop selling plan. We then dispatch Horizon's
 * native cart:update event; the cart components re-fetch and re-render their own section
 * (assets/component-cart-items.js #handleCartUpdate), and the prompt re-evaluates for the next step.
 *
 * One delegated listener (survives cart re-renders); not a global patch.
 */
document.addEventListener('click', async (event) => {
  const trigger = event.target instanceof Element ? event.target.closest('[data-knack-cart-upgrade]') : null;
  if (!trigger || trigger.getAttribute('aria-busy') === 'true') return;

  const variantId = trigger.dataset.variantId;
  const lineKey = trigger.dataset.lineKey;
  const sellingPlanId = trigger.dataset.sellingPlanId;
  const quantity = Number(trigger.dataset.quantity) || 1;
  if (!variantId || !lineKey) return;

  event.preventDefault();
  trigger.setAttribute('aria-busy', 'true');

  try {
    // 1. Add the new line first (non-destructive).
    const item = { id: Number(variantId), quantity };
    if (sellingPlanId) item.selling_plan = Number(sellingPlanId);
    // Hidden line-item property marks the line as a subscription for the order-confirmation
    // email. All Loop plans are 4-weekly today.
    if (sellingPlanId) item.properties = { _delivery_frequency: '4 weeks' };
    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] }),
    });
    if (!addRes.ok) throw new Error('cart/add failed');

    // 2. Remove the original line by its key.
    const changeRes = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: lineKey, quantity: 0 }),
    });
    if (!changeRes.ok) throw new Error('cart/change failed');
    const cart = await changeRes.json();

    // 3. Re-render the Horizon-native way: dispatch cart:update (no sections payload, so each cart
    //    component re-fetches its own section). This also re-renders this prompt for the next step.
    document.dispatchEvent(new CartUpdateEvent(cart, 'knack-cart-upgrade', { source: 'knack-cart-upgrade' }));
  } catch (error) {
    trigger.removeAttribute('aria-busy');
    console.error('knack-cart-upgrade:', error);
  }
});
